import { createAction } from 'typesafe-actions';

export const UPDATE_SELECTEDDATEYOGACLASS = 'selectedDateYogaClass/UPDATE_SELECTEDDATEYOGACLASS';

export const getSelectedDateYogaClassAsync = createAction(UPDATE_SELECTEDDATEYOGACLASS, ({ ...parameters }) => ({ ...parameters }))()


